/*
  Questo componente serve per il render della singola voce di menu in base alla tipologia "TipoVoceMenu":
   - Folder (TipoVoceMenu = 1): contenitore padre di altre voci di menu
   - Pagina (TipoVoceMenu = 2): pagina Azione sulla quale effettuare il redirect
 */

<template>
  <li class="nav-menu-li">
    <a
      v-if="menuitem.TipoVoceMenu === 2"
      class="nav-menu-li-link"
      :title="menuitem.Testo"
      :class="{'custom': menuitem.IsCustom, 'selected': menuitem.Id == selectedId}"
      :href="menuitem.Azione"
      @click="setSelected(menuitem.Id)"
    >
      <img
        :src="`${menuitem.IconaPath}`"
        :alt="menuitem.Testo"
        class="nav-menu-li-icon"
      />
      <span class="nav-menu-li-voce" :title="menuitem.Testo">{{menuitem.Testo}}</span>
    </a>
    <span v-else>
      <img
        :src="`${menuitem.IconaPath}`"
        :alt="menuitem.Testo"
        class="nav-menu-li-icon"
      />
      <span class="nav-menu-li-voce" :title="menuitem.Testo" @click="toggleOpenfolder(menuitem.Id)">{{menuitem.Testo}}</span>
    </span>
    <ul v-show="isFolderOpen(menuitem.Id)" v-if="menuitem.Children.length > 0" class="nav-menu-ul">
      <MenuItem
        v-for="menuitemchild in menuitem.Children"
        :key="menuitemchild.Id"
        :menuitem="menuitemchild"
        :selectedId="selectedId"
        :OpenFolder="OpenFolder"
      />
    </ul>
  </li>
</template>
<script>
export default {
  name: "MenuItem",
  props: {
    menuitem: Object,
    selectedId: Number,
    OpenFolder: Array
  },
  methods: {
    isFolderOpen (id) {
      if (this.OpenFolder) {
        return this.OpenFolder.includes(id)
      }
      return false
    },
    toggleOpenfolder (id) {
      this.$store.dispatch('menu/toggleOpenfolder', id)      
    },
    setSelected (id) {
      this.$store.dispatch('menu/setSelected', id)      
    }
  }
};
</script>